import { styled } from '@linaria/react';

const DefaultButton = styled.button`
  border: revert;
  background: revert;
  padding: 0.5rem;
  text-align: center;
  cursor: default;
  color: revert;
`;

export default DefaultButton;
